import {useDispatch} from "react-redux";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import SLAView from "./SLAView";
import {
getOSSLA,

} from "../../../actions/i4Actions";


const useStyles = makeStyles(theme => ({

}));


const PainelTVSLA = ( props ) => {
    const classes = useStyles();

    const dispatch = useDispatch();


    useEffect( () => {
            dispatch(getOSSLA());
            props.setTitulo("ORDENS X PRAZO");
    }, [props.contador]);


    return (
        <React.Fragment>
                        <SLAView/>
        </React.Fragment>
    )

}
export default (PainelTVSLA);


